export default {
  "b2b.renderers.aktivni.vyluka": "Lockout",
  "b2b.renderers.ano-ne.ano": "YES",
  "b2b.renderers.ano-ne.ne": "NO",
  "b2b.renderers.poznamka-modi.label": "Modified note",
  "b2b.renderers.poznamka-modi.zakaznik": "Customer",
  "b2b.renderers.poznamka-modi.spravce": "Administrator",
  "b2b.renderers.poznamka-modi.strojvedouci": "Train driver"
};
